"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.midnightColorPalette = void 0;
var _colorOptions = require("../colorOptions");
var midnightColorPalette = exports.midnightColorPalette = {
  navBackground: _colorOptions.imColors.gray700,
  navBackgroundSelected: _colorOptions.imColors.gray100,
  navIndicator: _colorOptions.imColors.gray25,
  onNavBackground: _colorOptions.imColors.gray25,
  onNavBackgroundSelected: _colorOptions.imColors.gray700,
  primary: _colorOptions.imColors.gray800,
  surfaceContainerLow: _colorOptions.imColors.gray50
};